<template>
  <v-row>
    <template v-if="this.chartType === 'Current'">
      <v-col cols="12" md="6" sm="6">
        <template v-if="this.customColors != null">
          <AnyPieChart
            :label="[
              $t('home.dashboardChart.Charts2_PieChart.currentLoad.y1'), //
              $t('home.dashboardChart.Charts2_PieChart.currentLoad.y2'), //
              $t('home.dashboardChart.Charts2_PieChart.currentLoad.y3'), //
            ]"
            :value="[
              this.dataPieCharts.currentLoad[0] + 'kW', //
              this.dataPieCharts.currentLoad[1] + 'kW', //
              this.dataPieCharts.currentLoad[2] + 'kW', //
            ]"
            :dark="$vuetify.theme.dark"
            :data="this.dataPieCharts.currentLoad"
            :color="
              $vuetify.theme.dark
                ? [
                    this.customColors.dark.fromGrid[0],
                    this.customColors.dark.fromGrid[1],
                    this.customColors.dark.fromGrid[2],
                    this.customColors.dark.pv[0],
                    this.customColors.dark.pv[1],
                    this.customColors.dark.pv[2],
                    this.customColors.dark.fromBattery[0],
                    this.customColors.dark.fromBattery[1],
                    this.customColors.dark.fromBattery[2],
                  ]
                : [
                    this.customColors.light.fromGrid[0],
                    this.customColors.light.fromGrid[1],
                    this.customColors.light.fromGrid[2],
                    this.customColors.light.pv[0],
                    this.customColors.light.pv[1],
                    this.customColors.light.pv[2],
                    this.customColors.light.fromBattery[0],
                    this.customColors.light.fromBattery[1],
                    this.customColors.light.fromBattery[2],
                  ]
            "
            :height="this.height"
            :width="this.width"
          />
        </template>

        <!--         <DashboardChart
          chartId="Charts2_PieChart1"
          chartType="Pie"
          :data="[
              this.dataPieCharts.currentLoad[0],
              this.dataPieCharts.currentLoad[1],
              this.dataPieCharts.currentLoad[2]
            ]"
          :labels="[
              $t('home.dashboardChart.Charts2_PieChart.currentLoad.y1'),
              $t('home.dashboardChart.Charts2_PieChart.currentLoad.y2'),
              $t('home.dashboardChart.Charts2_PieChart.currentLoad.y3'),
           ]"
          :backgroundColor="[
            this.gridPColor+this.backgroundOpacity, 
            this.pvColor+this.backgroundOpacity, 
            this.batteryPColor+this.backgroundOpacity, 
          ]"
          :hoverBackgroundColor="[
            this.gridPColor+this.hoverBackgroundOpacity, 
            this.pvColor+this.hoverBackgroundOpacity, 
            this.batteryPColor+this.hoverBackgroundOpacity, 
          ]"
          :hoverBorderColor="[
            this.gridPColor+this.hoverBorderOpacity, 
            this.pvColor+this.hoverBorderOpacity, 
            this.batteryPColor+this.hoverBorderOpacity, 
          ]"
        />-->
      </v-col>

      <v-col cols="12" md="6" sm="6">
        <template v-if="this.customColors != null">
          <AnyPieChart
            :label="[
              $t('home.dashboardChart.Charts2_PieChart.pv.y1'), //
              $t('home.dashboardChart.Charts2_PieChart.pv.y2'), //
              $t('home.dashboardChart.Charts2_PieChart.pv.y3'), //
            ]"
            :value="[
              this.dataPieCharts.currentPV[0] + 'kW', //
              this.dataPieCharts.currentPV[1] + 'kW', //
              this.dataPieCharts.currentPV[2] + 'kW', //
            ]"
            :dark="$vuetify.theme.dark"
            :data="this.dataPieCharts.currentPV"
            :color="
              $vuetify.theme.dark
                ? [
                    this.customColors.dark.load[0],
                    this.customColors.dark.load[1],
                    this.customColors.dark.load[2],
                    this.customColors.dark.toGrid[0],
                    this.customColors.dark.toGrid[1],
                    this.customColors.dark.toGrid[2],
                    this.customColors.dark.toBattery[0],
                    this.customColors.dark.toBattery[1],
                    this.customColors.dark.toBattery[2],
                  ]
                : [
                    this.customColors.light.load[0],
                    this.customColors.light.load[1],
                    this.customColors.light.load[2],
                    this.customColors.light.toGrid[0],
                    this.customColors.light.toGrid[1],
                    this.customColors.light.toGrid[2],
                    this.customColors.light.toBattery[0],
                    this.customColors.light.toBattery[1],
                    this.customColors.light.toBattery[2],
                  ]
            "
            :height="this.height"
            :width="this.width"
          />
        </template>

        <!--         <DashboardChart
          chartId="Charts2_PieChart2"
          chartType="Pie"
          :data="[
              this.dataPieCharts.currentPV[0],
              this.dataPieCharts.currentPV[1],
              this.dataPieCharts.currentPV[2]
            ]"
          :labels="[
              $t('home.dashboardChart.Charts2_PieChart.pv.y1'),
              $t('home.dashboardChart.Charts2_PieChart.pv.y2'),
              $t('home.dashboardChart.Charts2_PieChart.pv.y3'),
           ]"
          :backgroundColor="[
            this.loadColor+this.backgroundOpacity,
            this.gridNColor+this.backgroundOpacity, 
            this.batteryNColor+this.backgroundOpacity,
          ]"
          :hoverBackgroundColor="[
            this.loadColor+this.hoverBackgroundOpacity,
            this.gridNColor+this.hoverBackgroundOpacity,
            this.batteryNColor+this.hoverBackgroundOpacity,
          ]"
          :hoverBorderColor="[
            this.loadColor+this.hoverBorderOpacity,
            this.gridNColor+this.hoverBorderOpacity,
            this.batteryNColor+this.hoverBorderOpacity,
          ]"
        />-->
      </v-col>
    </template>

    <template v-else-if="this.chartType === 'Today'">
      <v-col cols="12" md="6" sm="6">
        <template v-if="this.customColors != null">
          <AnyPieChart
            :label="[
              $t('home.dashboardChart.Charts2_PieChart.load.y1'), //
              $t('home.dashboardChart.Charts2_PieChart.load.y2'), //
              $t('home.dashboardChart.Charts2_PieChart.load.y3'), //
            ]"
            :value="[
              this.dataPieCharts.todayLoad[0] + 'kWh', //
              this.dataPieCharts.todayLoad[1] + 'kWh', //
              this.dataPieCharts.todayLoad[2] + 'kWh', //
            ]"
            :dark="$vuetify.theme.dark"
            :data="this.dataPieCharts.todayLoad"
            :color="
              $vuetify.theme.dark
                ? [
                    this.customColors.dark.fromGrid[0],
                    this.customColors.dark.fromGrid[1],
                    this.customColors.dark.fromGrid[2],
                    this.customColors.dark.pv[0],
                    this.customColors.dark.pv[1],
                    this.customColors.dark.pv[2],
                    this.customColors.dark.fromBattery[0],
                    this.customColors.dark.fromBattery[1],
                    this.customColors.dark.fromBattery[2],
                  ]
                : [
                    this.customColors.light.fromGrid[0],
                    this.customColors.light.fromGrid[1],
                    this.customColors.light.fromGrid[2],
                    this.customColors.light.pv[0],
                    this.customColors.light.pv[1],
                    this.customColors.light.pv[2],
                    this.customColors.light.fromBattery[0],
                    this.customColors.light.fromBattery[1],
                    this.customColors.light.fromBattery[2],
                  ]
            "
            :height="this.height"
            :width="this.width"
          />
        </template>

        <!--         <DashboardChart
          chartId="Charts2_PieChart3"
          chartType="Pie"
          :data="[
              this.dataPieCharts.todayLoad[0],
              this.dataPieCharts.todayLoad[1],
              this.dataPieCharts.todayLoad[2],
            ]"
          :labels="[
              $t('home.dashboardChart.Charts2_PieChart.load.y1'),
              $t('home.dashboardChart.Charts2_PieChart.load.y2'),
              $t('home.dashboardChart.Charts2_PieChart.load.y3'),
           ]"
          :backgroundColor="[
            this.gridPColor+this.backgroundOpacity, 
            this.pvColor+this.backgroundOpacity, 
            this.batteryPColor+this.backgroundOpacity, 
          ]"
          :hoverBackgroundColor="[
            this.gridPColor+this.hoverBackgroundOpacity, 
            this.pvColor+this.hoverBackgroundOpacity, 
            this.batteryPColor+this.hoverBackgroundOpacity, 
          ]"
          :hoverBorderColor="[
            this.gridPColor+this.hoverBorderOpacity, 
            this.pvColor+this.hoverBorderOpacity, 
            this.batteryPColor+this.hoverBorderOpacity, 
          ]"
        />-->
      </v-col>

      <v-col cols="12" md="6" sm="6">
        <template v-if="this.customColors != null">
          <AnyPieChart
            :label="[
              $t('home.dashboardChart.Charts2_PieChart.pv.y1'), //
              $t('home.dashboardChart.Charts2_PieChart.pv.y2'), //
              $t('home.dashboardChart.Charts2_PieChart.pv.y3'), //
            ]"
            :value="[
              this.dataPieCharts.todayPV[0] + 'kWh', //
              this.dataPieCharts.todayPV[1] + 'kWh', //
              this.dataPieCharts.todayPV[2] + 'kWh', //
            ]"
            :dark="$vuetify.theme.dark"
            :data="this.dataPieCharts.todayPV"
            :color="
              $vuetify.theme.dark
                ? [
                    this.customColors.dark.load[0],
                    this.customColors.dark.load[1],
                    this.customColors.dark.load[2],
                    this.customColors.dark.toGrid[0],
                    this.customColors.dark.toGrid[1],
                    this.customColors.dark.toGrid[2],
                    this.customColors.dark.toBattery[0],
                    this.customColors.dark.toBattery[1],
                    this.customColors.dark.toBattery[2],
                  ]
                : [
                    this.customColors.light.load[0],
                    this.customColors.light.load[1],
                    this.customColors.light.load[2],
                    this.customColors.light.toGrid[0],
                    this.customColors.light.toGrid[1],
                    this.customColors.light.toGrid[2],
                    this.customColors.light.toBattery[0],
                    this.customColors.light.toBattery[1],
                    this.customColors.light.toBattery[2],
                  ]
            "
            :height="this.height"
            :width="this.width"
          />
        </template>

        <!--         <DashboardChart
          chartId="Charts2_PieChart4"
          chartType="Pie"
          :data="[
              this.dataPieCharts.todayPV[0],
              this.dataPieCharts.todayPV[1],
              this.dataPieCharts.todayPV[2],
            ]"
          :labels="[
              $t('home.dashboardChart.Charts2_PieChart.pv.y1'),
              $t('home.dashboardChart.Charts2_PieChart.pv.y2'),
              $t('home.dashboardChart.Charts2_PieChart.pv.y3'),
           ]"
          :backgroundColor="[
            this.loadColor+this.backgroundOpacity, 
            this.gridNColor+this.backgroundOpacity, 
            this.batteryNColor+this.backgroundOpacity, 
          ]"
          :hoverBackgroundColor="[
            this.loadColor+this.hoverBackgroundOpacity, 
            this.gridNColor+this.hoverBackgroundOpacity, 
            this.batteryNColor+this.hoverBackgroundOpacity, 
          ]"
          :hoverBorderColor="[
            this.loadColor+this.hoverBorderOpacity, 
            this.gridNColor+this.hoverBorderOpacity, 
            this.batteryNColor+this.hoverBorderOpacity, 
          ]"
        />-->
      </v-col>
    </template>

    <template v-else-if="this.chartType === 'Today2'">
      <v-col cols="12" md="6" sm="6">
        <template v-if="this.customColors != null">
          <AnyPieChart
            :label="[
              $t('home.dashboardChart.Charts2_PieChart.charging.y1'),
              $t('home.dashboardChart.Charts2_PieChart.charging.y2'),
            ]"
            :value="[
              this.dataPieCharts.todayCharging[0] + 'kWh',
              this.dataPieCharts.todayCharging[1] + 'kWh',
            ]"
            :dark="$vuetify.theme.dark"
            :data="this.dataPieCharts.todayCharging"
            :color="
              $vuetify.theme.dark
                ? [
                    this.customColors.dark.fromGrid[0],
                    this.customColors.dark.fromGrid[1],
                    this.customColors.dark.fromGrid[2],
                    this.customColors.dark.pv[0],
                    this.customColors.dark.pv[1],
                    this.customColors.dark.pv[2],
                  ]
                : [
                    this.customColors.light.fromGrid[0],
                    this.customColors.light.fromGrid[1],
                    this.customColors.light.fromGrid[2],
                    this.customColors.light.pv[0],
                    this.customColors.light.pv[1],
                    this.customColors.light.pv[2],
                  ]
            "
            :height="this.height"
            :width="this.width"
          />
        </template>

        <!--         <DashboardChart
          chartId="Charts2_PieChart5"
          chartType="Pie"
          :data="[
              this.dataPieCharts.todayCharging[0],
              this.dataPieCharts.todayCharging[1],
            ]"
          :labels="[
              $t('home.dashboardChart.Charts2_PieChart.charging.y1'),
              $t('home.dashboardChart.Charts2_PieChart.charging.y2'),
           ]"
          :backgroundColor="[
            this.gridPColor+this.backgroundOpacity, 
            this.pvColor+this.backgroundOpacity, 
          ]"
          :hoverBackgroundColor="[
            this.gridPColor+this.hoverBackgroundOpacity, 
            this.pvColor+this.hoverBackgroundOpacity, 
          ]"
          :hoverBorderColor="[
            this.gridPColor+this.hoverBorderOpacity, 
            this.pvColor+this.hoverBorderOpacity, 
          ]"
        />-->
      </v-col>

      <v-col cols="12" md="6" sm="6">
        <template v-if="this.customColors != null">
          <AnyPieChart
            :label="[
              $t('home.dashboardChart.Charts2_PieChart.battery.y1'),
              $t('home.dashboardChart.Charts2_PieChart.battery.y2'),
            ]"
            :value="[
              this.dataPieCharts.todayBattery[0] + 'kWh',
              this.dataPieCharts.todayBattery[1] + 'kWh',
            ]"
            :dark="$vuetify.theme.dark"
            :data="this.dataPieCharts.todayBattery"
            :color="
              $vuetify.theme.dark
                ? [
                    this.customColors.dark.toBattery[0],
                    this.customColors.dark.toBattery[1],
                    this.customColors.dark.toBattery[2],
                    this.customColors.dark.fromBattery[0],
                    this.customColors.dark.fromBattery[1],
                    this.customColors.dark.fromBattery[2],
                  ]
                : [
                    this.customColors.light.toBattery[0],
                    this.customColors.light.toBattery[1],
                    this.customColors.light.toBattery[2],
                    this.customColors.light.fromBattery[0],
                    this.customColors.light.fromBattery[1],
                    this.customColors.light.fromBattery[2],
                  ]
            "
            :height="this.height"
            :width="this.width"
          />
        </template>

        <!--         <DashboardChart
          chartId="Charts2_PieChart6"
          chartType="Pie"
          :data="[
              this.dataPieCharts.todayBattery[0],
              this.dataPieCharts.todayBattery[1],
            ]"
          :labels="[
              $t('home.dashboardChart.Charts2_PieChart.battery.y1'),
              $t('home.dashboardChart.Charts2_PieChart.battery.y2'),
           ]"
          :backgroundColor="[
            this.batteryNColor+this.backgroundOpacity, 
            this.batteryPColor+this.backgroundOpacity, 
          ]"
          :hoverBackgroundColor="[
            this.batteryNColor+this.hoverBackgroundOpacity, 
            this.batteryPColor+this.hoverBackgroundOpacity, 
          ]"
          :hoverBorderColor="[
            this.batteryNColor+this.hoverBorderOpacity, 
            this.batteryPColor+this.hoverBorderOpacity, 
          ]"
        />-->
      </v-col>
    </template>

    <template v-else-if="this.chartType === 'Yesterday'">
      <v-col cols="12" md="6" sm="6">
        <template v-if="this.customColors != null">
          <AnyPieChart
            :label="[
              $t('home.dashboardChart.Charts2_PieChart.load.y1'),
              $t('home.dashboardChart.Charts2_PieChart.load.y2'),
              $t('home.dashboardChart.Charts2_PieChart.load.y3'),
            ]"
            :value="[
              this.dataPieCharts.prevDayLoad[0] + 'kWh', //
              this.dataPieCharts.prevDayLoad[1] + 'kWh', //
              this.dataPieCharts.prevDayLoad[2] + 'kWh', //
            ]"
            :dark="$vuetify.theme.dark"
            :data="this.dataPieCharts.prevDayLoad"
            :color="
              $vuetify.theme.dark
                ? [
                    this.customColors.dark.fromGrid[0],
                    this.customColors.dark.fromGrid[1],
                    this.customColors.dark.fromGrid[2],
                    this.customColors.dark.pv[0],
                    this.customColors.dark.pv[1],
                    this.customColors.dark.pv[2],
                    this.customColors.dark.fromBattery[0],
                    this.customColors.dark.fromBattery[1],
                    this.customColors.dark.fromBattery[2],
                  ]
                : [
                    this.customColors.light.fromGrid[0],
                    this.customColors.light.fromGrid[1],
                    this.customColors.light.fromGrid[2],
                    this.customColors.light.pv[0],
                    this.customColors.light.pv[1],
                    this.customColors.light.pv[2],
                    this.customColors.light.fromBattery[0],
                    this.customColors.light.fromBattery[1],
                    this.customColors.light.fromBattery[2],
                  ]
            "
            :height="this.height"
            :width="this.width"
          />
        </template>

        <!--         <DashboardChart
          chartId="Charts2_PieChart7"
          chartType="Pie"
          :data="[
              this.dataPieCharts.prevDayLoad[0],
              this.dataPieCharts.prevDayLoad[1],
              this.dataPieCharts.prevDayLoad[2],
            ]"
          :labels="[
              $t('home.dashboardChart.Charts2_PieChart.load.y1'),
              $t('home.dashboardChart.Charts2_PieChart.load.y2'),
              $t('home.dashboardChart.Charts2_PieChart.load.y3'),
           ]"
          :backgroundColor="[
            this.gridPColor+this.backgroundOpacity, 
            this.pvColor+this.backgroundOpacity, 
            this.batteryPColor+this.backgroundOpacity, 
          ]"
          :hoverBackgroundColor="[
            this.gridPColor+this.hoverBackgroundOpacity, 
            this.pvColor+this.hoverBackgroundOpacity, 
            this.batteryPColor+this.hoverBackgroundOpacity, 
          ]"
          :hoverBorderColor="[
            this.gridPColor+this.hoverBorderOpacity, 
            this.pvColor+this.hoverBorderOpacity, 
            this.batteryPColor+this.hoverBorderOpacity, 
          ]"
        />-->
      </v-col>

      <v-col cols="12" md="6" sm="6">
        <template v-if="this.customColors != null">
          <AnyPieChart
            :label="[
              $t('home.dashboardChart.Charts2_PieChart.pv.y1'),
              $t('home.dashboardChart.Charts2_PieChart.pv.y2'),
              $t('home.dashboardChart.Charts2_PieChart.pv.y3'),
            ]"
            :value="[
              this.dataPieCharts.prevDayPV[0] + 'kWh', //
              this.dataPieCharts.prevDayPV[1] + 'kWh', //
              this.dataPieCharts.prevDayPV[2] + 'kWh', //
            ]"
            :dark="$vuetify.theme.dark"
            :data="this.dataPieCharts.prevDayPV"
            :color="
              $vuetify.theme.dark
                ? [
                    this.customColors.dark.load[0],
                    this.customColors.dark.load[1],
                    this.customColors.dark.load[2],
                    this.customColors.dark.toGrid[0],
                    this.customColors.dark.toGrid[1],
                    this.customColors.dark.toGrid[2],
                    this.customColors.dark.toBattery[0],
                    this.customColors.dark.toBattery[1],
                    this.customColors.dark.toBattery[2],
                  ]
                : [
                    this.customColors.light.load[0],
                    this.customColors.light.load[1],
                    this.customColors.light.load[2],
                    this.customColors.light.toGrid[0],
                    this.customColors.light.toGrid[1],
                    this.customColors.light.toGrid[2],
                    this.customColors.light.toBattery[0],
                    this.customColors.light.toBattery[1],
                    this.customColors.light.toBattery[2],
                  ]
            "
            :height="this.height"
            :width="this.width"
          />
        </template>

        <!--         <DashboardChart
          chartId="Charts2_PieChart8"
          chartType="Pie"
          :data="[
              this.dataPieCharts.prevDayPV[0],
              this.dataPieCharts.prevDayPV[1],
              this.dataPieCharts.prevDayPV[2],
            ]"
          :labels="[
              $t('home.dashboardChart.Charts2_PieChart.pv.y1'),
              $t('home.dashboardChart.Charts2_PieChart.pv.y2'),
              $t('home.dashboardChart.Charts2_PieChart.pv.y3'),
           ]"
          :backgroundColor="[
            this.loadColor+this.backgroundOpacity, 
            this.gridNColor+this.backgroundOpacity, 
            this.batteryNColor+this.backgroundOpacity, 

          ]"
          :hoverBackgroundColor="[
            this.loadColor+this.hoverBackgroundOpacity, 
            this.gridNColor+this.hoverBackgroundOpacity, 
            this.batteryNColor+this.hoverBackgroundOpacity, 

          ]"
          :hoverBorderColor="[
            this.loadColor+this.hoverBorderOpacity, 
            this.gridNColor+this.hoverBorderOpacity, 
            this.batteryNColor+this.hoverBorderOpacity, 

          ]"
        />-->
      </v-col>
    </template>

    <template v-else-if="this.chartType === 'Yesterday2'">
      <v-col cols="12" md="6" sm="6">
        <template v-if="this.customColors != null">
          <AnyPieChart
            :label="[
              $t('home.dashboardChart.Charts2_PieChart.charging.y1'),
              $t('home.dashboardChart.Charts2_PieChart.charging.y2'),
            ]"
            :value="[
              this.dataPieCharts.prevDayCharging[0] + 'kWh', //
              this.dataPieCharts.prevDayCharging[1] + 'kWh', //
            ]"
            :dark="$vuetify.theme.dark"
            :data="this.dataPieCharts.prevDayCharging"
            :color="
              $vuetify.theme.dark
                ? [
                    this.customColors.dark.fromGrid[0],
                    this.customColors.dark.fromGrid[1],
                    this.customColors.dark.fromGrid[2],
                    this.customColors.dark.pv[0],
                    this.customColors.dark.pv[1],
                    this.customColors.dark.pv[2],
                  ]
                : [
                    this.customColors.light.fromGrid[0],
                    this.customColors.light.fromGrid[1],
                    this.customColors.light.fromGrid[2],
                    this.customColors.light.pv[0],
                    this.customColors.light.pv[1],
                    this.customColors.light.pv[2],
                  ]
            "
            :height="this.height"
            :width="this.width"
          />
        </template>

        <!--         <DashboardChart
          chartId="Charts2_PieChart9"
          chartType="Pie"
          :data="[
              this.dataPieCharts.prevDayCharging[0],
              this.dataPieCharts.prevDayCharging[1],
            ]"
          :labels="[
              $t('home.dashboardChart.Charts2_PieChart.charging.y1'),
              $t('home.dashboardChart.Charts2_PieChart.charging.y2'),
           ]"
          :backgroundColor="[
            this.gridPColor+this.backgroundOpacity, 
            this.pvColor+this.backgroundOpacity, 
          ]"
          :hoverBackgroundColor="[
            this.gridPColor+this.hoverBackgroundOpacity, 
            this.pvColor+this.hoverBackgroundOpacity, 
          ]"
          :hoverBorderColor="[
            this.gridPColor+this.hoverBorderOpacity, 
            this.pvColor+this.hoverBorderOpacity, 
          ]"
        />-->
      </v-col>
      <v-col cols="12" md="6" sm="6">
        <template v-if="this.customColors != null">
          <AnyPieChart
            :label="[
              $t('home.dashboardChart.Charts2_PieChart.battery.y1'),
              $t('home.dashboardChart.Charts2_PieChart.battery.y2'),
            ]"
            :value="[
              this.dataPieCharts.prevDayBattery[0] + 'kWh', //
              this.dataPieCharts.prevDayBattery[1] + 'kWh', //
            ]"
            :dark="$vuetify.theme.dark"
            :data="this.dataPieCharts.prevDayBattery"
            :color="
              $vuetify.theme.dark
                ? [
                    this.customColors.dark.toBattery[0],
                    this.customColors.dark.toBattery[1],
                    this.customColors.dark.toBattery[2],
                    this.customColors.dark.fromBattery[0],
                    this.customColors.dark.fromBattery[1],
                    this.customColors.dark.fromBattery[2],
                  ]
                : [
                    this.customColors.light.toBattery[0],
                    this.customColors.light.toBattery[1],
                    this.customColors.light.toBattery[2],
                    this.customColors.light.fromBattery[0],
                    this.customColors.light.fromBattery[1],
                    this.customColors.light.fromBattery[2],
                  ]
            "
            :height="this.height"
            :width="this.width"
          />
        </template>

        <!--         <DashboardChart
          chartId="Charts2_PieChart10"
          chartType="Pie"
          :data="[
              this.dataPieCharts.prevDayBattery[0],
              this.dataPieCharts.prevDayBattery[1],
            ]"
          :labels="[
              $t('home.dashboardChart.Charts2_PieChart.battery.y1'),
              $t('home.dashboardChart.Charts2_PieChart.battery.y2'),
           ]"
          :backgroundColor="[
            this.batteryNColor+this.backgroundOpacity, 
            this.batteryPColor+this.backgroundOpacity, 
          ]"
          :hoverBackgroundColor="[
            this.batteryNColor+this.hoverBackgroundOpacity, 
            this.batteryPColor+this.hoverBackgroundOpacity, 
          ]"
          :hoverBorderColor="[
            this.batteryNColor+this.hoverBorderOpacity, 
            this.batteryPColor+this.hoverBorderOpacity, 
          ]"
        />-->
      </v-col>
    </template>

    <template v-else-if="this.chartType === 'Weekly'">
      <v-col cols="12" md="6" sm="6">
        <v-chip>Připravuje se</v-chip>
      </v-col>
      <v-col cols="12" md="6" sm="6"></v-col>
    </template>
    <template v-else-if="this.chartType === 'Monthly'">
      <v-col cols="12" md="6" sm="6">
        <v-chip>Připravuje se</v-chip>
      </v-col>
      <v-col cols="12" md="6" sm="6"></v-col>
    </template>
    <template v-else-if="this.chartType === 'Yearly'">
      <v-col cols="12" md="6" sm="6">
        <v-chip>Připravuje se</v-chip>
      </v-col>
      <v-col cols="12" md="6" sm="6"></v-col>
    </template>
    <template v-else></template>
  </v-row>
</template>

<script>
import { customColors } from "../../colors.js";

import AnyPieChart from "./AnyPieChart.vue";

/* import DashboardChart from "./DashboardChart.vue"; */

export default {
  name: "OverviewPieCharts",
  components: {
    /*     DashboardChart, */
    AnyPieChart,
  },
  props: {
    chartType: {
      type: String,
      default: "",
      require: true,
    },
    dataPieCharts: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      customColors: null,

      height: 200,
      width: 200,

      /*       loadColor: "rgba(211, 47, 47,",
      inverterPColor: "rgba(120, 147, 161,",
      inverterNColor: "rgba(96, 125, 139,",
      gridPColor: "rgba(123, 31, 162,",
      gridNColor: "rgba(3, 169, 244,",
      batteryPColor: "rgba(104, 159, 56,",
      batteryNColor: "rgba(0, 200, 83,",
      pvColor: "rgba(251, 192, 45,",

      backgroundOpacity: "0.9)",
      hoverBackgroundOpacity: "0.6)",
      hoverBorderOpacity: "0.6)", */
    };
  },
  mounted() {
    this.customColors = customColors;
  },
};
</script>

<style scoped></style>
